export default {
  loading: 'Загрузка...',
  date_time_same_today: "Сегодня",
  date_time_same_today_at: "Сегодня в",
  date_time_same_yesterday: "Вчера",
  date_time_same_yesterday_at: "Вчера в",
  date_time_same_at: "в",
  month_1: "Январь",
  month_2: "Февраль",
  month_3: "Март",
  month_4: "Апрель",
  month_5: "Май",
  month_6: "Июнь",
  month_7: "Июль",
  month_8: "Август",
  month_9: "Сентябрь",
  month_10: "Октябрь",
  month_11: "Ноябрь",
  month_12: "Декабрь",
  mon_1: "Янв",
  mon_2: "Фев",
  mon_3: "Мар",
  mon_4: "Апр",
  mon_5: "Май",
  mon_6: "Июн",
  mon_7: "Июл",
  mon_8: "Авг",
  mon_9: "Сен",
  mon_10: "Окт",
  mon_11: "Ноя",
  mon_12: "Дек",
  online: 'Онлайн',
  offline: 'Оффлайн',
  success: 'Успех',
  error: 'Ошибка',
  save: 'Сохранить',
  log_out: 'Выйти',
}
